import React, { useState, useRef, useLayoutEffect } from "react";
import clsx from "clsx";
import styles from "./ExpandableText.module.css";
import { trimEmptyLines } from "utils/text";

const ExpandableText = ({
  text,
  maxLines = 5,
  className,
  collapsedClass,
  renderHtml,    // ваш хелпер renderHtmlText
}) => {
  const [isExpanded, setExpanded] = useState(false);
  const [canToggle, setCanToggle] = useState(false);  
  const [showButton, setShowButton] = useState(false);
  const containerRef = useRef(null);

  text = trimEmptyLines(text);

  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    //  
    // scrollHeight — полная «высота» содержимого,
    // clientHeight — то, что видно
    //
    if (el.scrollHeight > el.clientHeight) {
      setCanToggle(true);
    }
  }, [text]);

  return (
    <div>
      <div
        ref={containerRef}
        className={clsx(className, {
          [styles.collapsedText]: !isExpanded,
        })}
      >
        { renderHtml(text) }
      </div>

      {canToggle && (
        <button
          className={styles.expandButton}
          onClick={() => setExpanded((v) => !v)}
        >
          {isExpanded ? "Свернуть" : "Развернуть"}
        </button>
      )}
    </div>
  );
};

export default ExpandableText;
